import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

const AirplaneIcon: FunctionComponent<Props> = ({ className = '', testId = TEST_ID }) => (
    <svg
        className={className}
        data-testid={testId}
        fill='none'
        height='28'
        viewBox='0 0 24 24'
        width='28'
        xmlns='http://www.w3.org/2000/svg'>
        <path
            d='M21 16v-2l-8-5V3.5a1.5 1.5 0 0 0-3 0V9l-8 5v2l8-2.5V19l-2 1.5V22l3.5-1 3.5 1v-1.5L13 19v-5.5l8 2.5z'
            stroke='currentColor'
            strokeLinejoin='round'
            strokeWidth='1.4'
        />
    </svg>
);

export default AirplaneIcon;
